export default __webpack_public_path__ + "static/soundboard-ed0c59a5ee350d3a54a138b97c5139c0.png";